import { render, staticRenderFns } from "./CompareComment.vue?vue&type=template&id=0e268051&scoped=true&"
import script from "./CompareComment.vue?vue&type=script&lang=ts&"
export * from "./CompareComment.vue?vue&type=script&lang=ts&"
import style0 from "./CompareComment.vue?vue&type=style&index=0&id=0e268051&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e268051",
  null
  
)

export default component.exports